"use client"
import React, { useEffect } from 'react';
import { FaEnvelope, FaFacebook, FaInstagram, FaMapMarkerAlt, FaPhone, FaTwitter } from 'react-icons/fa';
import 'ol/ol.css';
import Map from 'ol/Map';
import View from 'ol/View';
import TileLayer from 'ol/layer/Tile';
import OSM from 'ol/source/OSM';
import { Feature, Kinetic } from 'ol';
import * as olProj from 'ol/proj';
import VectorSource from 'ol/source/Vector';
import VectorLayer from 'ol/layer/Vector';
import Style from 'ol/style/Style';
import { Point } from 'ol/geom';
import Icon from 'ol/style/Icon';

const Footer: React.FC = () => {  
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const map = new Map({
        target: 'map',
        layers: [
          new TileLayer({
            source: new OSM(),
          }),
        ],
        view: new View({
          center: olProj.fromLonLat([20.33235331221797, 43.88359299609428]),
          zoom: 15,
        }),
      });

      const marker = new Feature({
        geometry: new Point(olProj.fromLonLat([20.33235331221797, 43.88359299609428])),
      });

      const markerStyle = new Style({
        image: new Icon({
          src: '/images/pin.png',
          scale: 1
        }),
      });

      marker.setStyle(markerStyle);

      const vectorSource = new VectorSource({
        features: [marker],
      });
      
      const vectorLayer = new VectorLayer({
        source: vectorSource,
      });

      
      map.addLayer(vectorLayer);
    }
  }, []);

  return (
    <footer id='contact' className="ftco-footer ftco-section px-3">
      <div className="container">
        <div className="row mb-5">
          <div className="col-md">
            <div className="ftco-footer-widget mb-4">
              <div className='flex flex-direction-row mb-2'>
                <img className='mr-4' src='/images/icon.svg' width={70} />
                <h2 style={{ width: '50%', marginBottom: 0 }}>berberaj032</h2>
              </div>
              <p style={{ textAlign: 'justify' }}>Naša misija je da svakom klijentu pružimo jedinstveno iskustvo koje spaja profesionalnu uslugu, savremene tehnike, i pažljivo odabrane proizvode. Bez obzira na to da li tražite klasičnu eleganciju, moderni stil ili nešto potpuno novo, naš tim posvećenih frizera tu je da vaše želje pretvori u stvarnost. Berberaj032 – mesto gde vaša kosa postaje pravo umetničko delo!</p>
              <ul className="ftco-footer-social list-unstyled float-md-left float-lft mt-1">
                <li className=""><a target="_blank" href="https://www.instagram.com/bobanin.berberaj/"><FaInstagram className="icon-twitter" style={{ width: '100%', height: '100%', color: '' }}/></a></li>
              </ul>
            </div>
          </div>
          <div className="col-md">
            <div className="ftco-footer-widget mb-4 ml-md-5">
              <h2 className="ftco-heading-2">Pronađite nas</h2>
              <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2875.6996821097277!2d20.32985267615076!3d43.88277353755238!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4757722510725baf%3A0xcf0cef5ff733cbbe!2z0KHRgtC-0ZjQtSDQotC-0YjQuNGbIDEyLCDQp9Cw0YfQsNC6!5e0!3m2!1ssr!2srs!4v1736967893873!5m2!1ssr!2srs" width="100%" height="200px" style={{ border :"0" }} allowFullScreen={false} loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
            </div>
          </div>
          <div className="col-md">
            <div className="ftco-footer-widget mb-4">
            	<h2 className="ftco-heading-2">Imate pitanje?</h2>
            	<div className="block-23 mb-3">
	              <ul>
	                <li><FaMapMarkerAlt className='icon' /><span className="text">Bulevar Vuka Karadžića 39, Čačak</span></li>
	                <li><FaPhone className="icon icon-phone" /><span className="text">060 422 3434 / 060 381 6000</span></li>
	                <li><FaEnvelope className="icon icon-envelope" /><span className="text">berberaj032@gmail.com</span></li>
	              </ul>
	            </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12 text-center">

            <p>
              Copyright &copy; 2025 Sva prava zadržana | Sajt kreirali Darko Radulović i Jovica Cvetić
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
